import React, { useEffect, useState } from 'react';
import { Card, Table } from 'antd';
import styles from './index.module.scss';
import k1 from '@/assets/images/k-1.png';
import k2 from '@/assets/images/k-2.png';
import k3 from '@/assets/images/k-3.png';
import k4 from '@/assets/images/k-4.png';
import k5 from '@/assets/images/k-5.png';
import k6 from '@/assets/images/k-6.png';
import k7 from '@/assets/images/k-7.png';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';




const OBSStudioUserGuide: React.FC = () => {


  const [troubleshootingData, setTroubleshootingData] = useState<any[]>([]);

  const [troubleshootingColumns, setTroubleshootingColumns] = useState<any[]>([]);

  //国际化语言切换
  const { t } = useTranslation();


  useEffect(() => {

    // 故障排除数据
    const troubleshootingData2 = [
      {
        key: '1',
        issue: i18n.t('obsguide.field1'),
        cause: i18n.t('obsguide.field2'),
        solution: i18n.t('obsguide.field3')
      },
      {
        key: '2',
        issue: i18n.t('obsguide.field4'),
        cause: i18n.t('obsguide.field5'),
        solution: i18n.t('obsguide.field6')
      },
      {
        key: '3',
        issue: i18n.t('obsguide.field7'),
        cause: i18n.t('obsguide.field8'),
        solution: i18n.t('obsguide.field9')
      },
      {
        key: '4',
        issue: i18n.t('obsguide.field10'),
        cause: i18n.t('obsguide.field11'),
        solution: i18n.t('obsguide.field12')
      }
    ];

    setTroubleshootingData(troubleshootingData2);

    // 故障排除表格列定义
    const troubleshootingColumns2 = [
      {
        title: i18n.t('obsguide.table1'),
        dataIndex: 'issue',
        key: 'issue',
        width: '30%',
      },
      {
        title: i18n.t('obsguide.table2'),
        dataIndex: 'cause',
        key: 'cause',
        width: '35%',
      },
      {
        title: i18n.t('obsguide.table3'),
        dataIndex: 'solution',
        key: 'solution',
        width: '35%',
      },
    ];

    setTroubleshootingColumns(troubleshootingColumns2);
    
  }, [])

  return (
    <div className={styles['obs-guide-container']}>
      <div className={styles['guide-header']}>
        <h1 className={styles['guide-title']}>{t('obsguide.title')}</h1>
      </div>

      <div className={styles['guide-content']}>
        {/* Download and Installation */}
        <div className={styles['guide-section']}>
          <div className={styles['section-layout']}>
            <div className={styles['section-text']}>
              <h2 className={styles['section-title']}>{t('obsguide.subtitle1')}</h2>
              <ol className={styles['step-list']}>
                <li>{t('obsguide.text1')} <a href="https://obsproject.com" target="_blank" rel="noopener noreferrer">https://obsproject.com</a></li>
                <li>{t('obsguide.text2')}</li>
                <li>{t('obsguide.text3')}</li>
                <li>{t('obsguide.text4')}</li>
                <li>{t('obsguide.text5')}</li>
                <li>{t('obsguide.text6')}</li>
              </ol>
            </div>
            <div className={styles['section-image']}>
              <img src={k1} alt="OBS Studio Download" />
            </div>
          </div>
        </div>

        {/* Initial Setup */}
        <div className={styles['guide-section']}>
          <div className={styles['section-layout']}>
            <div className={styles['section-text']}>
              <h2 className={styles['section-title']}>{t('obsguide.subtitle2')}</h2>
              <ol className={styles['step-list']}>
                <li>{t('obsguide.text7')}</li>
                <li>{t('obsguide.text8')}</li>
                <li>{t('obsguide.text9')}</li>
                <li>{t('obsguide.text10')}</li>
              </ol>
            </div>
            <div className={styles['section-image']}>
              <img src={k2} alt="OBS Studio Initial Setup" />
            </div>
          </div>
        </div>

        {/* Configure Streaming Settings */}
        <div className={styles['guide-section']}>
          <div className={styles['section-layout']}>
            <div className={styles['section-text']}>
              <h2 className={styles['section-title']}>{t('obsguide.subtitle3')}</h2>
              <ol className={styles['step-list']}>
                <li>{t('obsguide.text11')}</li>
                <li>{t('obsguide.text12')}</li>
                <li>{t('obsguide.text13')}</li>
                <li>{t('obsguide.text14')}</li>
              </ol>
              <div className={styles['tip-box']}>
                {t('obsguide.note1')}
              </div>
            </div>
            <div className={styles['section-image']}>
              <img src={k3} alt="Configure Streaming Settings" />
            </div>
          </div>
        </div>

        {/* Setting Up Your Scene */}
        <div className={styles['guide-section']}>
          <div className={styles['section-layout']}>
            <div className={styles['section-text']}>
              <h2 className={styles['section-title']}>{t('obsguide.subtitle4')}</h2>
              <ol className={styles['step-list']}>
                <li>{t('obsguide.text15')}</li>
                <li>{t('obsguide.text16')}</li>
                <li>{t('obsguide.text17')}</li>
                <li>{t('obsguide.text18')}</li>
              </ol>
            </div>
            <div className={styles['section-image']}>
              <img src={k4} alt="Setting Up Your Scene" />
            </div>
          </div>
        </div>

        {/* Audio Settings */}
        <div className={styles['guide-section']}>
          <div className={styles['section-layout']}>
            <div className={styles['section-text']}>
              <h2 className={styles['section-title']}>{t('obsguide.subtitle5')}</h2>
              <ol className={styles['step-list']}>
                <li>{t('obsguide.text19')}</li>
                <li>{t('obsguide.text20')}</li>
                <li>{t('obsguide.text21')}</li>
              </ol>
            </div>
            <div className={styles['section-image']}>
              <img src={k5} alt="Audio Settings" />
            </div>
          </div>
        </div>

        {/* Start Live Streaming */}
        <div className={styles['guide-section']}>
          <div className={styles['section-layout']}>
            <div className={styles['section-text']}>
              <h2 className={styles['section-title']}>{t('obsguide.subtitle6')}</h2>
              <ol className={styles['step-list']}>
                <li>{t('obsguide.text22')}</li>
                <li>{t('obsguide.text23')}</li>
                <li>{t('obsguide.text24')}</li>
                <li>{t('obsguide.text25')}</li>
              </ol>
            </div>
            <div className={styles['section-image']}>
              <img src={k6} alt="Start Live Streaming" />
            </div>
          </div>
        </div>

        {/* Troubleshooting */}
        <div className={styles['guide-section']}>
          <div className={styles['section-full']}>
            <h2 className={styles['section-title']}>{t('obsguide.subtitle7')}</h2>
            <Table
              columns={troubleshootingColumns}
              dataSource={troubleshootingData}
              pagination={false}
              className={styles['troubleshooting-table']}
            />
          </div>
        </div>

        {/* Recommended Settings */}
        <div className={styles['guide-section']}>
          <div className={styles['section-layout']}>
            <div className={styles['section-text']}>
              <h2 className={styles['section-title']}>{t('obsguide.subtitle8')}</h2>
              <ul className={styles['settings-list']}>
                <li>{t('obsguide.text26')}</li>
                <li>{t('obsguide.text27')}</li>
                <li>{t('obsguide.text28')}</li>
                <li>{t('obsguide.text29')}</li>
                <li>{t('obsguide.text30')}</li>
                <li>{t('obsguide.text31')}</li>
              </ul>
            </div>
            <div className={styles['section-image']}>
              <img src={k7} alt="Recommended Settings" />
            </div>
          </div>
        </div>

        {/* Tips for Better Performance */}
        <div className={styles['guide-section']}>
          <div className={styles['section-full']}>
            <h2 className={styles['section-title']}>{t('obsguide.subtitle9')}</h2>
            <ul className={styles['tips-list']}>
              <li>{t('obsguide.text32')}</li>
              <li>{t('obsguide.text33')}</li>
              <li>{t('obsguide.text34')}</li>
              <li>{t('obsguide.text35')}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OBSStudioUserGuide; 